import { render, staticRenderFns } from "./agendaMobile.vue?vue&type=template&id=805df800&scoped=true"
import script from "./agendaMobile.vue?vue&type=script&lang=js"
export * from "./agendaMobile.vue?vue&type=script&lang=js"
import style0 from "./agendaMobile.vue?vue&type=style&index=0&id=805df800&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805df800",
  null
  
)

export default component.exports